import React from 'react';
import { useIntl } from 'react-intl';
import { MUSIC_VIDEO_END_CARD_LINES, type MusicVideoEndCardLine } from 'fym-shared/src/music24/musicVideoLook';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { endCardLineMessages, panelMessages } from '../messages/panelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The end card fields (design d2): the line ("Out now", "Pre-save now", … or by the release day)
 * and the link. The link is the SmartLink of the song (`texts.endCard.smartLinkUuid` stays null:
 * the editor answer names only the SmartLink of the song).
 */
const EndCardFieldsComponent: React.FC = () => {
  const intl = useIntl();
  const { doc, data, change, readOnly } = useMusicVideoEditor();
  return (
    <>
      <span className={styles.eyebrow}>{intl.formatMessage(panelMessages.endCardEyebrow)}</span>
      <div className={styles.inspectorGrid}>
        <label className={styles.rowLabel} htmlFor="music-video-end-line">
          {intl.formatMessage(panelMessages.endLine)}
        </label>
        <select
          id="music-video-end-line"
          className={styles.select}
          value={doc.texts.endCard.line}
          disabled={readOnly}
          onChange={(event) => {
            const line = event.target.value as MusicVideoEndCardLine;
            change((current) => ({
              ...current,
              texts: { ...current.texts, endCard: { ...current.texts.endCard, line } },
            }));
          }}
        >
          {MUSIC_VIDEO_END_CARD_LINES.map((line) => (
            <option key={line} value={line}>
              {intl.formatMessage(endCardLineMessages[line])}
            </option>
          ))}
        </select>
        <span className={styles.rowLabel}>{intl.formatMessage(panelMessages.endLink)}</span>
        <span className={styles.field}>
          {intl.formatMessage(data.song.smartLinkUuid === null ? panelMessages.endLinkNone : panelMessages.endLinkSong)}
        </span>
      </div>
    </>
  );
};

export const EndCardFields = TypedMemo(EndCardFieldsComponent);
